import { lazyLoad } from 'utils/loadable';

export const StockAdjustmentPage = lazyLoad(
  () => import('./index'),
  module => module.StockAdjustmentPage
);
